import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTranslate = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.5 4.16667H5.83333M5.83333 4.16667H9.16667C9.16667 6.63427 7.826 8.78875 5.83333 9.94145M5.83333 4.16667L5.83333 2.5M5.83333 9.94145C4.85276 10.5087 3.71429 10.8333 2.5 10.8333M5.83333 9.94145C4.82124 9.35599 3.97735 8.51209 3.39188 7.5M5.83333 9.94145C6.81391 10.5087 7.95238 10.8333 9.16667 10.8333M17.5 17.5V17.4475C17.5 16.6198 17.4124 15.7997 17.2418 15M10.8333 17.5V17.4475C10.8333 16.6198 10.9209 15.7997 11.0915 15M11.0915 15C11.4699 13.2268 12.2568 11.554 13.4035 10.1207C13.7947 9.63159 14.5386 9.63159 14.9299 10.1207C16.0765 11.554 16.8634 13.2268 17.2418 15M11.0915 15H17.2418",
		stroke: "#3F3F46",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgTranslate);
export default ForwardRef;
